import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { useAuth } from "../../context/AuthContext";

const EditUser = () => {
  const { id } = useParams(); // ID de l'utilisateur à modifier
  const { user: currentUser } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    role: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Charger les données de l'utilisateur depuis Firestore
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userRef = doc(db, "users", id);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          setError("Utilisateur non trouvé.");
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de l'utilisateur :", err);
        setError("Erreur lors de la récupération de l'utilisateur.");
      }
      setLoading(false);
    };
    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const userRef = doc(db, "users", id);
      await updateDoc(userRef, userData);
      navigate("/admin/users");
    } catch (err) {
      console.error("Erreur lors de la mise à jour de l'utilisateur :", err);
      setError("Erreur lors de la mise à jour de l'utilisateur.");
    }
  };

  if (loading) return <div className="p-8">Chargement...</div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;

  return (
    <div className="max-w-md mx-auto mt-12 p-4">
      <h2 className="text-2xl font-bold mb-4">Modifier l'utilisateur</h2>
      {error && <div className="mb-4 text-red-600">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-semibold text-sm">Prénom</label>
          <input
            type="text"
            name="firstName"
            value={userData.firstName}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1 text-sm"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-sm">Nom</label>
          <input
            type="text"
            name="lastName"
            value={userData.lastName}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1 text-sm"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-sm">Entreprise</label>
          <input
            type="text"
            name="company"
            value={userData.company}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1 text-sm"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-sm">Email</label>
          <input
            type="email"
            name="email"
            value={userData.email}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1 text-sm"
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-sm">Rôle</label>
          <select
            name="role"
            value={userData.role}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1 text-sm"
          >
            <option value="">Sélectionnez un rôle</option>
            <option value="superadmin">Super Admin</option>
            <option value="projectmanager">Chef de Projet</option>
            <option value="charge-affaire">Chargé(e) d'affaire</option>
            <option value="client">Client</option>
          </select>
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-1 text-sm rounded hover:bg-blue-700 transition"
        >
          Sauvegarder
        </button>
      </form>
    </div>
  );
};

export default EditUser;
